import { axiosRequest } from '../api';
import { API_PATH } from '../../constants';

export const VacationService = {
  getVacationsList(params){ return axiosRequest('GET', API_PATH.VACATION.LIST(params)) },
  getVacation(data){ return axiosRequest('POST', API_PATH.VACATION.INFO, data) },
  addVacation(data){ return axiosRequest('POST', API_PATH.VACATION.ADD, data) },
  deleteVacation(data){ return axiosRequest('POST', API_PATH.VACATION.DELETE, data) },
}